module.exports = __webpack_public_path__ + "img/school5.c6cf9cf4.png";